module.exports = __webpack_public_path__ + "img/budget-sidebar-icon.26af84a0.svg";